import React, { useEffect, useState } from "react";
import Header from "../../../components/Header";
import SearchInputV2 from "../../../components/Ecommerce/SearchInputV2";
import SearchResultV2 from "../../../components/Ecommerce/SearchResultV2";
import { useSharedLinkParam } from "../../../hooks/useSharedLinkParam";
import { useWrongPlatformRedirect } from "../../../hooks/useWrongPlatformRedirect";
import FooterV2 from "../../../components/FooterV2";
import CashBackGuide from "../../../components/Ecommerce/CashBackGuide";
import LongHouseePet from "../../../components/Ecommerce/LongHouseePet";
import AnswerQuestion from "../../../components/Q&A/Q&A";
import lazadaApi from "../../../api/lazadaApi";
import FindButton from "../../../components/Ecommerce/FindButton";
// import PolicyLazada from "../../../components/Ecommerce/PolicyLazada";
import Policy from "../../../components/Ecommerce/Policy";

function LazadaNew() {
    const [searchTerm, setSearchTerm] = useState("");
  // Link dán sẵn qua ?link= (block đợt thưởng, push giảm giá…) + câu nhắc thưởng thêm.
  const { initialLink, rewardNote } = useSharedLinkParam(searchTerm);
  useEffect(() => { if (initialLink) setSearchTerm(initialLink); }, [initialLink]);
    const [productList, setProductList] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    // Hỏng do HỆ THỐNG (5xx / mất mạng) chứ không phải sản phẩm không có hoa hồng.
    // Hai ca này phải nói hai câu khác nhau — xem ghi chú ở chỗ catch bên dưới.
    const [systemError, setSystemError] = useState(false);

    // Dán nhầm sàn → mở trang đúng thay vì để API Lazada trả "không tìm thấy sản phẩm".
    const redirectIfWrongPlatform = useWrongPlatformRedirect("lazada");

    useEffect(() => {
        if (!searchTerm) return;
        if (redirectIfWrongPlatform(searchTerm)) return;
        setProductList([]);
        setSystemError(false);
        const fetchProductInfoByLink = async () => {
            setisLoading(true);
            try {
                const { data } = await lazadaApi.getProductInfo(searchTerm);
                setProductList([data.productInfo]);
            } catch (error) {
                console.log(error);
                setProductList([]);
                // 5xx hoặc không có response (mất mạng/VPS chết) = lỗi PHÍA MÌNH.
                // Trước đây mọi lỗi đều rơi vào câu "mặt hàng này không được hoàn tiền"
                // → cookie Lazada hết hạn là nói oan TẤT CẢ sản phẩm, user bỏ đi mua
                // ngoài app và mất hoàn tiền thật (sự cố 21/09/2026).
                const status = Number(error?.response?.status) || 0;
                setSystemError(status >= 500 || !error?.response);
            }
            setisLoading(false);
        };
        fetchProductInfoByLink();
    }, [searchTerm, redirectIfWrongPlatform]);

    return (
        <div className="h-dvh flex flex-col justify-between">
            <Header />
            <div className="pt-16 w-full md:w-[768px] lg:w-[1024px] mx-auto flex flex-col gap-2">
                <div>
                    <SearchInputV2
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        isLoading={isLoading}
                        platform={"lazada"}
                        cashBackTitle={
                            <span className="text-xs">
                                🔗 Dán link → ⏰ Hoàn tiền 24h - 48h → 💰 Rút tiền sau 45 ngày
                            </span>
                        }
                        titleTextColor={"text-blue-800"}
                        borderInputColor={"border-blue-800"}
                    />
                </div>
                {!searchTerm && <LongHouseePet platform={"Lazada"} />}
                {searchTerm && (
                    <SearchResultV2
                            rewardNote={rewardNote}
                        notFoundMsg={
                            systemError
                                ? 'Hệ thống đang bận nên chưa kiểm tra được sản phẩm này. Đơn của bạn VẪN được ghi nhận hoàn tiền nếu hợp lệ — bạn thử dán lại link sau ít giây nhé.'
                                : undefined
                        }
                        isLoading={isLoading}
                        platform={"lazada"}
                        productList={productList}
                        fromColorBg={"from-blue-600"}
                        toColorBg={"to-blue-800"}
                        buyBtnBgColor={"bg-blue-800"}
                        buyBtnTextColor={"text-blue-800"}
                        cashBackTextColor={"text-white"}
                    />
                )}

                {!searchTerm && (
                    <>
                        <FindButton
                            fromColorBg={"from-blue-200"}
                            toColorBg={"to-blue-900"}
                            fromColorText={"from-blue-800"}
                            toColorText={"to-blue-950"}
                            platform={"lazada"}
                        />
                        <div className="p-2 bg-surface">
                            <CashBackGuide
                                platform={"lazada"}
                                fromColorBg={"from-blue-600"}
                                toColorBg={"to-blue-800"}
                                borderColor={"border-blue-800"}
                            />
                        </div>
                        <Policy fromColorBg={"from-blue-600"} toColorBg={"to-blue-800"} />
                    </>
                )}

                <AnswerQuestion
                    postId={11}
                    fromColorBg={"from-blue-600"}
                    toColorBg={"to-blue-800"}
                />
            </div>
            <FooterV2 />
        </div>
    );
}

export default LazadaNew;
